var sanitizeText = function sanitizeText() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(s).replace(/\</g, '&lt;').replace(/\>/g, '&gt;');
};

export default sanitizeText;